// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-explorer ul {
  margin: unset;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}

.file-explorer .file-context-item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: space-between; */
  padding-inline-end: 4px;
  padding-inline-start: 0px;
  cursor: pointer;
  position: relative;
  height: 28px;
  gap: 4px;
}

.file-explorer .context-item-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
  overflow-x: hidden;
  gap: 4px;
}

.file-explorer .file-context-item .hide {
  visibility: hidden;
}

.file-explorer .file-context-item.selected {
  background-color: var(--primary-color) !important;
  color: white !important;
  fill: white !important;
}

.file-explorer .file-context-item:hover .option-button {
  display: flex !important;
  opacity: 1 !important;
}

.file-explorer .file-context-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.file-explorer .file-context-item .file-icon-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
}

.file-explorer .file-context-item .file-text-wrapper {
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.file-explorer .file-context-item.selected .file-text-wrapper {
  color: white !important;
}

.file-explorer .file-context-item .context-pipe-x {
  position: absolute;
  left: -7px;
  top: 15px;
  height: 2px;
  background-color: #e7e7e7;
  visibility: hidden;
}

.file-explorer .file-context-item .context-pipe-y {
  position: absolute;
  border-left: 2px solid var(--tertiary-font-color);
  left: -6px;
  top: 0px;
  z-index: -1;
}

.file-explorer-root {
  list-style-type: none;
  padding-inline-start: 0px;
  padding: 10px;
  position: relative;
}

.file-explorer-root ul {
  list-style-type: none;
  padding-inline-start: 0px;
  position: relative;
  padding-bottom: 5px;
}

.file-explorer-root > li:after {
  display: none;
}

.file-explorer .draggingSource {
  opacity: 0.3;
}

.file-explorer .placeholder {
  position: relative;
}

.file-explorer > ul > li > .file-context-item > div.pipeY {
  display: none;
}

.file-explorer li:has(> .droptarget) {
  outline: 3px solid #e8f0fe;
  border-radius: 4px;
}

.file-explorer-root {
  height: 100%;
}

.draggingSource {
  opacity: 0.3;
}

.file-explorer-placeholder {
  position: relative;
}

.file-explorer-droptarget {
  background-color: var(--tertiary-font-color);
}

.file-context-item .expand-icon-wrapper {
  align-items: center;
  font-size: 0;
  cursor: pointer;
  display: flex;
  height: 16px;
  justify-content: center;
  width: 16px;
  transform: rotate(0deg);
  visibility: hidden;
}

.file-context-item .expand-icon-wrapper.show {
  visibility: visible;
}

.file-context-item .expand-icon-wrapper.show.is-open {
  transform: rotate(180deg);
}

.file-explorer svg.darkmode-enabled,
.file-explorer .expand-icon-wrapper svg {
  fill: var(--editor-heading-font-color) !important;
}

.file-explorer .file-context-item.selected svg.darkmode-enabled,
.file-explorer .file-context-item.selected .expand-icon-wrapper svg {
  fill: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/FileExplorerMenu/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,sBAAsB;AACxB","sourcesContent":[".file-explorer ul {\n  margin: unset;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.file-explorer .file-context-item {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  /* justify-content: space-between; */\n  padding-inline-end: 4px;\n  padding-inline-start: 0px;\n  cursor: pointer;\n  position: relative;\n  height: 28px;\n  gap: 4px;\n}\n\n.file-explorer .context-item-wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  white-space: nowrap;\n  width: 100%;\n  overflow-x: hidden;\n  gap: 4px;\n}\n\n.file-explorer .file-context-item .hide {\n  visibility: hidden;\n}\n\n.file-explorer .file-context-item.selected {\n  background-color: var(--primary-color) !important;\n  color: white !important;\n  fill: white !important;\n}\n\n.file-explorer .file-context-item:hover .option-button {\n  display: flex !important;\n  opacity: 1 !important;\n}\n\n.file-explorer .file-context-item:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.file-explorer .file-context-item .file-icon-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-right: 4px;\n}\n\n.file-explorer .file-context-item .file-text-wrapper {\n  flex: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.file-explorer .file-context-item.selected .file-text-wrapper {\n  color: white !important;\n}\n\n.file-explorer .file-context-item .context-pipe-x {\n  position: absolute;\n  left: -7px;\n  top: 15px;\n  height: 2px;\n  background-color: #e7e7e7;\n  visibility: hidden;\n}\n\n.file-explorer .file-context-item .context-pipe-y {\n  position: absolute;\n  border-left: 2px solid var(--tertiary-font-color);\n  left: -6px;\n  top: 0px;\n  z-index: -1;\n}\n\n.file-explorer-root {\n  list-style-type: none;\n  padding-inline-start: 0px;\n  padding: 10px;\n  position: relative;\n}\n\n.file-explorer-root ul {\n  list-style-type: none;\n  padding-inline-start: 0px;\n  position: relative;\n  padding-bottom: 5px;\n}\n\n.file-explorer-root > li:after {\n  display: none;\n}\n\n.file-explorer .draggingSource {\n  opacity: 0.3;\n}\n\n.file-explorer .placeholder {\n  position: relative;\n}\n\n.file-explorer > ul > li > .file-context-item > div.pipeY {\n  display: none;\n}\n\n.file-explorer li:has(> .droptarget) {\n  outline: 3px solid #e8f0fe;\n  border-radius: 4px;\n}\n\n.file-explorer-root {\n  height: 100%;\n}\n\n.draggingSource {\n  opacity: 0.3;\n}\n\n.file-explorer-placeholder {\n  position: relative;\n}\n\n.file-explorer-droptarget {\n  background-color: var(--tertiary-font-color);\n}\n\n.file-context-item .expand-icon-wrapper {\n  align-items: center;\n  font-size: 0;\n  cursor: pointer;\n  display: flex;\n  height: 16px;\n  justify-content: center;\n  width: 16px;\n  transform: rotate(0deg);\n  visibility: hidden;\n}\n\n.file-context-item .expand-icon-wrapper.show {\n  visibility: visible;\n}\n\n.file-context-item .expand-icon-wrapper.show.is-open {\n  transform: rotate(180deg);\n}\n\n.file-explorer svg.darkmode-enabled,\n.file-explorer .expand-icon-wrapper svg {\n  fill: var(--editor-heading-font-color) !important;\n}\n\n.file-explorer .file-context-item.selected svg.darkmode-enabled,\n.file-explorer .file-context-item.selected .expand-icon-wrapper svg {\n  fill: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
